<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <jm-toolbar
          ref="toolbarvm"
          customize-field-name="offer"
          show-defined-search
          show-defined-list
        />
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>Offer列表</span>
          </div>
          <div class="searchList">
            <el-form
              :model="searchData"
              inline>
              <el-row>
                <!-- 搜索项结构  v-if="filterVisible(item.field)" -->
                <el-col
                  v-for="(item, index) in searchStructure"
                  :key="index"
                  :xs="item.column[0]"
                  :sm="item.column[1]"
                  :md="item.column[2]"
                  :lg="item.column[3]"
                  v-if="filterVisible(item.visible)">
                  <el-form-item :label="item.label">
                    <el-input
                      v-if="item.component === 1"
                      v-model="searchData[item.field]"
                      :placeholder="item.placeholder"
                      :title="item.placeholder"
                      :class="item.field"/>
                    <el-select
                      v-if="item.component === 2"
                      v-model="searchData[item.field]"
                      :placeholder="item.placeholder"
                      :title="item.placeholder"
                      :clearable="item.clearable"
                      filterable>
                      <el-option
                        v-for="option in options[item.option]"
                        v-if="filterTeacher(option.country)"
                        :key="option.userid"
                        :label="option.truename"
                        :value="option.userid"/>
                    </el-select>
                    <el-date-picker
                      v-if="item.component === 3"
                      v-model="searchData[item.field]"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :title="item.placeholder"
                      type="daterange"
                      :picker-options="pickerOptions"
                      :clearable="item.clearable"
                      filterable/>
                    <jm-dict-select
                      v-if="item.component === 4"
                      v-model="searchData[item.field]"
                      :placeholder="item.placeholder"
                      :title="item.placeholder"
                      :type="item.type"
                      :dict-type="item.dict"
                      :name="item.name || ''"
                      :clearable="item.clearable"
                      filterable/>
                    <jm-dict-select
                      v-if="item.component === 5"
                      v-model="searchData[item.field]"
                      :placeholder="item.placeholder"
                      :title="item.placeholder"
                      :type="item.type"
                      :dict-type="item.dict"
                      :filter="opt => opt.pid === searchData[item.filter]"
                      :clearable="item.clearable"
                      filterable/>
                    <jm-dict-select
                      v-if="item.component === 6"
                      v-model="searchData[item.field]"
                      :placeholder="item.placeholder"
                      :title="item.placeholder"
                      :type="item.type"
                      :dict-type="item.dict"
                      :filter="opt => $inCountry(opt.id)"
                      :clearable="item.clearable"
                      filterable/>
                    <el-select
                      v-if="item.component === 7"
                      v-model="searchData[item.field]"
                      :placeholder="item.placeholder"
                      :title="item.placeholder"
                      :clearable="item.clearable"
                      filterable>
                      <el-option
                        v-for="(option, index) in options[item.option]"
                        :key="index"
                        :label="option"
                        :value="option"/>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- /搜索项结构 -->
              </el-row>
            </el-form>
          </div>
          <div class="searchBottom">
            <el-button
              type="primary"
              class="jm-input-common3"
              @click="getSearch">查询</el-button>
            <el-button
              type="default"
              class="jm-input-common3"
              @click="setSearchData">重置</el-button>
          </div>
          <jm-tableList
            url="/index/offer/getPage"
            :refresh="refresh"
            :search-data="searchData"
            :current-page.sync="currentPage">
            <el-table-column
              slot="gpa_suanshu"
              label="GPA">
              <template slot-scope="scope">
                <div class="gpa">
                  <strong><span>算数平均分: </span>{{ scope.row.gpa_suanshu }}</strong><strong><span>加权平均分: </span>{{ scope.row.gpa_jiaquan }}</strong><strong><span>绩点: </span>{{ scope.row.gpa_jidian }}</strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              slot="app_order"
              prop="app_order"
              label="App排序"
              align="center"
              sortable>
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.app_order"
                  size="small"
                  @blur="setAppOrder(scope)"/>
              </template>
            </el-table-column>
            <el-table-column
              slot="ruxue_date"
              label="入学时间"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.kaixueqi_year !== 0 && scope.row.kaixueqi_month !== 0">{{ scope.row.kaixueqi_year }}年{{ scope.row.kaixueqi_month }}月</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="180"
              align="center"
              fixed="right">
              <template slot-scope="scope">
                <a
                  :href="`/frontend/student/order/${scope.row.crm_id}`"
                  target="_blank"
                  title="查看详情"><el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-document">查看
                </el-button></a>
                <el-button
                  size="mini"
                  :type="scope.row.is_recommend > 1 ? 'success' : 'danger'"
                  :icon="scope.row.is_recommend > 1 ? 'star-off' : 'star-on'"
                  :title="`${scope.row.is_recommend > 1 ? '开始' : '取消'}推荐`"
                  @click="setRecommend(scope)">{{ scope.row.is_recommend > 1 ? '开始推荐' : '取消推荐' }}</el-button>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import jmToolbar from '@/components/tool/toolbar';
import jmTableList from '@/components/data/tableList';
import { jmDictSelect } from '@/components/tool';
import { filterVisible } from '@/utils/utils';
import { shCountry } from '@/dataset/student';
import { getAdvisoryTeachers, getWriteTeachers } from '@/api/teacher';
// 搜索项结构
const searchStructure = [
  {
    visible: 'custom_name',
    field: 'custom_name',
    label: '学生姓名',
    placeholder: '学生姓名',
    component: 1,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'country_id',
    field: 'country_id',
    label: '意向国家',
    placeholder: '选择国家',
    component: 6,
    type: 'online',
    dict: 'country',
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'schoolname',
    field: 'schoolname',
    label: '申请学校',
    placeholder: '院校名称',
    component: 1,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'crm_sayer',
    field: 'crm_sayer',
    label: '咨询老师',
    placeholder: '老师姓名',
    component: 2,
    option: 'crm_sayer',
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'crm_writer',
    field: 'crm_writer',
    label: '申请老师',
    placeholder: '老师姓名',
    component: 2,
    option: 'crm_writer',
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'custom_course',
    field: 'custom_course',
    label: '意向课程',
    placeholder: '课程名称',
    component: 5,
    type: 'online',
    dict: 'course',
    filter: 'country_id',
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'custom_hope_way',
    field: 'custom_hope_way',
    label: '申请专业方向',
    placeholder: '专业方向名称',
    component: 5,
    type: 'college',
    dict: 'direction',
    filter: 'shcountry',
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'zhuanye_name',
    field: 'zhuanye_name',
    label: '申请专业',
    placeholder: '专业名称',
    component: 1,
    column: [24, 24, 16, 8]
  },
  {
    visible: 'shenqing_result',
    field: 'shenqing_result',
    label: '申请结果',
    placeholder: '结果状态',
    component: 4,
    type: 'dataset',
    dict: 'student',
    name: 'resShenqing',
    clearable: false,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'is_queren',
    field: 'is_queren',
    label: '申请状态',
    placeholder: '申请状态',
    component: 4,
    type: 'jiemo',
    dict: 'is_queren',
    clearable: false,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'is_copy',
    field: 'is_copy',
    label: '创建方式',
    placeholder: '选择方式',
    component: 4,
    type: 'dataset',
    dict: 'student',
    name: 'isCopy',
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'custom_purpose',
    field: 'custom_purpose',
    label: '案例综合分析',
    placeholder: '有无分析',
    component: 4,
    type: 'dataset',
    dict: 'student',
    name: 'customPurpose',
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'is_offer_img',
    field: 'is_offer_img',
    label: 'OFFER图片',
    placeholder: '是否已作',
    component: 4,
    type: 'dataset',
    dict: 'student',
    name: 'isOfferImg',
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'offer_img_uptime',
    field: 'offer_img_uptime',
    label: '制作时间',
    placeholder: '制作时间范围',
    component: 3,
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'gpa',
    field: 'gpa_type',
    label: 'GPA',
    placeholder: '计算方式',
    component: 4,
    type: 'dataset',
    dict: 'student',
    name: 'gpaType',
    column: [12, 12, 8, 4]
  },
  {
    visible: 'gpa',
    field: 'gpa_min',
    placeholder: '',
    component: 1,
    column: [6, 6, 4, 2]
  },
  {
    visible: 'gpa',
    field: 'gpa_max',
    placeholder: '',
    component: 1,
    column: [6, 6, 4, 2]
  },
  {
    visible: 'add_time',
    field: 'add_time',
    label: '创建时间',
    placeholder: '时间范围',
    component: 3,
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'is_recommend',
    field: 'is_recommend',
    label: '是否推荐',
    placeholder: '是否',
    component: 4,
    type: 'dataset',
    dict: 'student',
    name: 'isRecommend',
    clearable: true,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'custom_school',
    field: 'custom_school',
    label: '最后就读学校',
    placeholder: '学校名称',
    component: 1,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'custom_major',
    field: 'custom_major',
    label: '最后就读专业',
    placeholder: '专业名称',
    component: 1,
    column: [12, 12, 8, 8]
  },
  {
    visible: 'ruxue_date',
    field: 'ruxue_year',
    label: '入学日期',
    placeholder: '年',
    component: 7,
    option: 'ruxue_year',
    clearable: true,
    column: [12, 12, 5, 4]
  },
  {
    visible: 'ruxue_date',
    field: 'ruxue_month',
    placeholder: '月',
    component: 7,
    option: 'ruxue_month',
    clearable: true,
    column: [12, 12, 2, 2]
  },
  {
    visible: 'review_status',
    field: 'review_status',
    label: '学生口碑',
    placeholder: '请选择',
    component: 4,
    clearable: true,
    type: 'dataset',
    dict: 'student',
    name: 'isKoubei',
    column: [12, 12, 8, 8]
  },
  {
    visible: 'id',
    field: 'id',
    label: '申请编号',
    placeholder: '申请编号',
    component: 1,
    column: [12, 12, 8, 8]
  },
];
  // options
const options = {
  ruxue_year: [],
  ruxue_month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12]
};
  // picker选项
const pickerOptions = {
  disabledDate(time) {
    return time.getTime() > Date.now();
  },
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - (3600 * 1000 * 24 * 7));
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - (3600 * 1000 * 24 * 30));
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - (3600 * 1000 * 24 * 90));
        picker.$emit('pick', [start, end]);
      }
    }
  ]
};
// 搜索数据结构
const searchData = {
  custom_name: '',
  country_id: '',
  schoolname: '',
  shcountry: 0,
  crm_sayer: '',
  crm_writer: '',
  custom_course: '',
  custom_hope_way: '',
  zhuanye_name: '',
  shenqing_result: '',
  is_queren: -1,
  custom_purpose: '',
  is_offer_img: '',
  offer_img_uptime: '',
  gpa_type: 2,
  gpa_min: '',
  gpa_max: '',
  gpa: {
    type: '',
    min: '',
    max: '',
  },
  add_time: '',
  is_recommend: '',
  custom_school: '',
  custom_major: '',
  ruxue_date: {
    year: '',
    month: ''
  },
  year: '',
  month: '',
  review_status: '',
  id: '',
};

export default {
  components: {
    jmToolbar, jmTableList, jmDictSelect
  },
  data() {
    return {
      tableListInited: false,
      searchStructure,
      pickerOptions,
      appOrder: 0,
      options,
      searchData: {},
      currentPage: 1
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 监听状态刷新数据
    refresh() {
      return this.$store.state.student.refresh;
    },
  },
  methods: {
    filterVisible,
    // 初始默认搜索值
    setSearchData() {
      this.searchData = Object.assign({}, searchData);
    },
    getSearch() {
      this.currentPage = 1;
      this.searchData.isSearch = false;
      Object.values(this.searchData).forEach((item) => {
        if (item) {
          this.searchData.isSearch = true;
        }
      });
      this.$store.commit('updateRefresh', true);
    },
    // 获取当前App排序并备份
    getAppOrder({ row }) {
      this.appOrder = row.app_order;
    },
    // 设置当前App排序
    setAppOrder({ row }) {
      // 如果当前排序未改变则取消提交
      if (this.appOrder === row.app_order) {
        return false;
      }
      this.$http
        ._post({
          url: '/index/offer/setAppOrder',
          data: { app_order: row.app_order, id: row.id }
        })
        .then(({ data }) => {
          if (data === 1) {
            this.getSearch();
            this.appOrder = 0;
          }
        });
    },
    // 设置是否推荐
    setRecommend({ row }) {
      let isRecommend = row.is_recommend > 1 ? 1 : 2;
      let oText = row.is_recommend > 1 ? '开始' : '取消';
      this
        .$confirm(`确定要${oText}推荐？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          this.$http
            ._post({
              url: '/index/offer/setRecommend',
              data: { is_recommend: isRecommend, id: row.id }
            })
            .then(({ data }) => {
              this.$message({
                type: 'success',
                message: `${oText}推荐成功`
              });
              if (data === 1) {
                this.getSearch();
              }
            });
        })
        .catch(() => {
          return false;
        });
    },
    filterTeacher(countryId) {
      let europeCountry = [30, 31, 674, 673, 1770, 675, 1831, 1869, 1870, 1871, 1872, 1867, 1874, 1877, 1876, 1875, 1879, 1839, 1878, -1];
      let result = false;
      if (europeCountry.includes(countryId) && europeCountry.includes(this.searchData.country_id)) {
        result = true;
      } else if (countryId === this.searchData.country_id) {
        result = true;
      }
      return result;
    }
  },
  created() {
    // 获取当前用户的国家
    // let uc = this.userInfo.countries.filter(item => item > 0);
    // if (uc.length > 0 && uc[0] > 0) {
    // searchData.country_id = uc[0];
    // }
    // 因为默认查询字段为空，初始设置查询数据字段
    this.setSearchData();
    // 获取咨询老师与文案老师
    Promise.all([getAdvisoryTeachers(), getWriteTeachers()])
      .then((data) => {
        this.options.crm_sayer = data[0].data;
        this.options.crm_writer = data[1].data;
      });
    // 年份计算，当年及后4年
    for (let i = 0; i < 5; i++) {
      let _year = new Date().getFullYear();
      options.ruxue_year.push(_year + i);
    }
  },
  watch: {
    'searchData.country_id'(id) {
      let shcountry = 0;
      shCountry.forEach((item) => {
        if (item.value === id) {
          shcountry = +item.label;
        }
      });
      this.setSearchData();
      this.searchData.shcountry = shcountry;
      this.searchData.country_id = id;
    },
    'searchData.gpa_type'(type) {
      this.searchData.gpa.type = type;
    },
    'searchData.gpa_min'(min) {
      this.searchData.gpa.min = min;
    },
    'searchData.gpa_max'(max) {
      this.searchData.gpa.max = max;
    },
    'searchData.ruxue_year'(year) {
      this.searchData.ruxue_date.year = year;
    },
    'searchData.ruxue_month'(month) {
      this.searchData.ruxue_date.month = month;
    },
  }
};
</script>
